import React from "react";

import { useQuery } from "@apollo/client";
import { Box, Divider, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import { formatISODate } from "@/utils/datetime";

import MealRatingLogsItem from "./MealRatingLogsItem";
import { ClientReportPageParams } from "../utils/types";

const useStyles = makeStyles()(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: 20,
  },
  title: {
    color: "#363E45",
    fontFamily: "Mulish",
    fontSize: 20,
    fontWeight: 700,
  },
}));

const mealRatingLogsQuery = graphql(`
  query mealRatingLogs($clientId: ID!, $consumedOn: ISO8601Date!) {
    mealRatingByDate(clientId: $clientId, consumedOn: $consumedOn) {
      rating
      consumedAt
      consumedOn
      mealType
    }
  }
`);

const MealRatingLogs: React.FC = () => {
  const { classes } = useStyles();
  const { clientId, date } = useParams<ClientReportPageParams>();
  const { data } = useQuery(mealRatingLogsQuery, {
    variables: {
      clientId: clientId ?? "",
      consumedOn: date ?? formatISODate(new Date()),
    },
  });

  const mealRatings = data?.mealRatingByDate;

  return (
    <Box className={classes.container}>
      <Typography className={classes.title}>Meal Logs</Typography>
      <Box height={24} />
      {mealRatings?.map((mealRating, index) => {
        const isLastIndex = mealRatings.length - 1 === index;

        return (
          <Box key={index}>
            <MealRatingLogsItem mealRating={mealRating} />
            {!isLastIndex && <Divider />}
          </Box>
        );
      })}
    </Box>
  );
};

export default MealRatingLogs;
